( function( $ ) {

    $(document).ready( function() {

        // Check if Splide is available
        if ( typeof Splide === 'undefined' ) {
            console.warn( 'Splide library not loaded.' );
            return;
        }

        // Initialize all slider blocks
        $( '.wp-block-st-slider' ).each( function() {
            const $block = $( this );
            const $textSlider = $block.find( '.slider-1' );
            const $imageSlider = $block.find( '.slider-2-slides' );
            const $prevBtn = $block.find( '.slider-btn-prev' );
            const $nextBtn = $block.find( '.slider-btn-next' );

            if ( ! $textSlider.length || ! $imageSlider.length ) return;

            // Common Splide options
            const options = {
                type: 'fade',          // Smooth fade transition
                perPage: 1,
                rewind: true,          // Loop back to first/last
                pagination: false,     // Hide default pagination (we use custom buttons)
                arrows: false,         // Hide default arrows (we use custom buttons)
                gap: 0,
                interval: 0,           // No auto-play
                speed: 400,
                easing: 'ease',
                
            };

            // Create two instances
            const textSplide = new Splide( $textSlider[0], options );
            const imageSplide = new Splide( $imageSlider[0], options );

            // Sync them so they move together
            textSplide.sync( imageSplide );

            // Mount both
            textSplide.mount();
            imageSplide.mount();

            // Wire custom prev/next buttons
            $prevBtn.on( 'click', function( e ) {
                e.preventDefault();
                textSplide.go( '<' );
            } );

            $nextBtn.on( 'click', function( e ) {
                e.preventDefault();
                textSplide.go( '>' );
            } );

            // Maintain the `.active` class for your existing CSS transitions
            // Splide adds its own `is-active` class; we also add/remove `active`
            const updateActiveClass = () => {
                // For text slides
                $textSlider.find( '.slide' ).removeClass( 'active' );
                $textSlider.find( '.is-active' ).addClass( 'active' );

                // For image slides
                $imageSlider.find( '.slide' ).removeClass( 'active' );
                $imageSlider.find( '.is-active' ).addClass( 'active' );
            };

            // Run on mount and after each move
            textSplide.on( 'mounted moved', updateActiveClass );
            imageSplide.on( 'mounted moved', updateActiveClass );
        } );

    } );

} )( jQuery );